(function () {
  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function moveModalToBody(sectionId) {
    const modal = document.getElementById(`ProductVariantModal-${sectionId}`);
    const overlay = document.getElementById(`ProductVariantModalOverlay-${sectionId}`);

    if (overlay && overlay.parentElement !== document.body) {
      document.body.appendChild(overlay);
    }

    if (modal && modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
  }

  function openModal(sectionId) {
    if (!isMobile()) return;

    moveModalToBody(sectionId);

    const modal = document.getElementById(`ProductVariantModal-${sectionId}`);
    const overlay = document.getElementById(`ProductVariantModalOverlay-${sectionId}`);

    if (!modal || !overlay) return;

    overlay.classList.add('-visible');
    modal.classList.add('-visible');
    document.documentElement.classList.add('variant-modal-open');
    document.body.classList.add('variant-modal-open');
  }

  function closeModal(sectionId) {
    const modal = document.getElementById(`ProductVariantModal-${sectionId}`);
    const overlay = document.getElementById(`ProductVariantModalOverlay-${sectionId}`);

    if (!modal || !overlay) return;

    overlay.classList.remove('-visible');
    modal.classList.remove('-visible');
    document.documentElement.classList.remove('variant-modal-open');
    document.body.classList.remove('variant-modal-open');
  }

  document.addEventListener('click', function (event) {
    const openButton = event.target.closest('[data-product-variant-modal-open]');

    if (openButton) {
      event.preventDefault();
      const sectionId = openButton.getAttribute('data-product-variant-modal-open');
      openModal(sectionId);
      return;
    }

    const closeButton = event.target.closest('[data-product-variant-modal-close]');

    if (closeButton) {
      event.preventDefault();
      const sectionId = closeButton.getAttribute('data-product-variant-modal-close');
      closeModal(sectionId);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('.product-variant-modal.-visible').forEach(function (modal) {
      const sectionId = modal.id.replace('ProductVariantModal-', '');
      closeModal(sectionId);
    });
  });

  window.addEventListener('resize', function () {
    if (isMobile()) return;

    document.querySelectorAll('.product-variant-modal.-visible').forEach(function (modal) {
      modal.classList.remove('-visible');
    });

    document.querySelectorAll('.product-variant-modal-overlay.-visible').forEach(function (overlay) {
      overlay.classList.remove('-visible');
    });

    document.documentElement.classList.remove('variant-modal-open');
    document.body.classList.remove('variant-modal-open');
  });
})();